import _react from "react";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
    r = _react,
    t = (e = r) && "object" == typeof e && "default" in e ? e.default : e;

function n(e, r) {
  (null == r || r > e.length) && (r = e.length);

  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];

  return n;
}

var o = function (e) {
  return t.createElement("div", null, e.children);
},
    i = function (e) {
  return t.createElement("span", {
    style: {
      whiteSpace: "pre"
    }
  }, e.children);
},
    u = function (e) {
  return t.createElement("span", null, e.children);
},
    a = r.memo(o),
    c = r.memo(i),
    l = r.memo(u),
    f = r.forwardRef(function (e, o) {
  var i = e.className,
      u = e.style,
      f = e.LineWrapper,
      s = void 0 === f ? a : f,
      p = e.WordWrapper,
      d = void 0 === p ? c : p,
      m = e.LetterWrapper,
      v = void 0 === m ? l : m,
      y = e.extraProps,
      h = "";
  t.Children.map(e.children, function (e) {
    if ("string" != typeof e && "number" != typeof e) throw new Error("SplitText expect a text as children");
    h += String(e);
  });
  var x = r.useRef(null),
      g = r.useState([]),
      b = g[0],
      E = g[1],
      w = r.useRef(0);
  r.useLayoutEffect(function () {
    return function () {
      var e = x.current;

      if (e) {
        if (b.length > 0) return function (e, r) {
          for (var t, o = w.current || e.map(function (e) {
            return e.length;
          }).sort(function (e, r) {
            return r - e;
          })[0], i = [], u = "", a = 0, c = function (e, r) {
            var t;

            if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
              if (Array.isArray(e) || (t = function (e, r) {
                if (e) {
                  if ("string" == typeof e) return n(e, void 0);
                  var t = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? n(e, void 0) : void 0;
                }
              }(e))) {
                t && (e = t);
                var o = 0;
                return function () {
                  return o >= e.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: e[o++]
                  };
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            return (t = e[Symbol.iterator]()).next.bind(t);
          }(r.split(" ").entries()); !(t = c()).done;) {
            var l = t.value[1];
            (a += l.length + 1) > o + 1 && (i.push(u), u = "", a = 0), u += l.trim() + " ";
          }

          i.push(u), E(i.map(function (e) {
            return e.trim();
          })), o > w.current && (w.current = o);
        }(b, h);

        for (var r, t = [], o = [], i = 0, u = Array.from(e.children); i < u.length; i++) {
          var a = u[i],
              c = a.getBoundingClientRect().top;
          null == r && (r = c), c !== r && (t.push(o.join(" ")), o = []), r = c, o.push((a.textContent || "").trim());
        }

        t.push(o.join(" ")), E(t);
      }
    }();
  }, [h]);
  var S = 0,
      I = 0;
  return b.length ? t.createElement("div", {
    className: i,
    ref: function (e) {
      x.current = e, "function" == typeof o ? o(e) : o && (o.current = e);
    },
    style: u
  }, b.map(function (e, r) {
    var n = e.split(" ");
    return n = n.map(function (e, r) {
      return r === n.length - 1 ? e : e + " ";
    }), t.createElement(s, {
      key: r,
      lineIndex: r,
      extraProps: y
    }, n.map(function (e, n) {
      var o = e.split("");
      return t.createElement(d, {
        key: n,
        lineIndex: r,
        wordIndex: n,
        countIndex: S++,
        extraProps: y
      }, o.map(function (e, o) {
        return t.createElement(v, {
          key: o,
          lineIndex: r,
          wordIndex: n,
          letterIndex: o,
          countIndex: I++,
          extraProps: y
        }, e);
      }));
    }));
  })) : t.createElement("div", {
    className: i,
    ref: x,
    style: u
  }, h.split(" ").map(function (e, r) {
    return t.createElement("span", {
      key: r
    }, e, " ");
  }));
}),
    s = r.forwardRef(function (e, n) {
  var o,
      i,
      u,
      a = e.children,
      c = function (e, r) {
    if (null == e) return {};
    var t,
        n,
        o = {},
        i = Object.keys(e);

    for (n = 0; n < i.length; n++) r.indexOf(t = i[n]) >= 0 || (o[t] = e[t]);

    return o;
  }(e, ["children"]),
      l = r.useState(0),
      s = l[0],
      p = l[1],
      d = (o = function () {
    return p(function (e) {
      return e + 1;
    });
  }, void 0 === i && (i = !1), function () {
    for (var e = this, r = arguments.length, t = new Array(r), n = 0; n < r; n++) t[n] = arguments[n];

    var a = i && !u,
        c = function () {
      return o.apply(e, t);
    };

    clearTimeout(u), u = setTimeout(c, 300), a && c();
  });

  return r.useEffect(function () {
    return window.addEventListener("resize", d), function () {
      return window.removeEventListener("resize", d);
    };
  }, []), t.createElement(f, Object.assign({
    key: s
  }, c, {
    ref: n
  }), a);
});

exports.LetterWrapper = u, exports.LineWrapper = o, exports.SplitText = s, exports.WordWrapper = i; //# sourceMappingURL=react-split-text.cjs.production.min.js.map

export default exports;